import { render, staticRenderFns } from "./BirthdayStats.vue?vue&type=template&id=2d5fc17c&"
import script from "./BirthdayStats.vue?vue&type=script&lang=js&"
export * from "./BirthdayStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports